import { render, staticRenderFns } from "./usulan.vue?vue&type=template&id=6722bfeb&"
import script from "./usulan.vue?vue&type=script&lang=js&"
export * from "./usulan.vue?vue&type=script&lang=js&"
import style0 from "./usulan.vue?vue&type=style&index=0&id=6722bfeb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QDialog,QIcon,QBtnGroup,QCardActions,QSelect,QFile,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QDialog,QIcon,QBtnGroup,QCardActions,QSelect,QFile})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
